export default __webpack_public_path__ + "static/media/mini_split_ductless.8018ae33.png";